(function () {
  'use strict';

  var CACHE_TTL_MS = 10 * 60 * 1000;
  var DEFAULT_FETCH_PAGE_SIZE = 250;

  function parseCardsFromHtml(html) {
    if (!html) return [];

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = doc.querySelector('[data-gk-blog-posts-source]');

    if (source) {
      return Array.from(source.querySelectorAll('.gk-blog-post-card'));
    }

    return Array.from(doc.querySelectorAll('.gk-blog-post-card'));
  }

  function getCardTimestamp(card) {
    var timestamp = parseInt(card.getAttribute('data-updated-at') || '', 10);

    if (!Number.isNaN(timestamp) && timestamp > 0) {
      return timestamp;
    }

    var timeEl = card.querySelector('time[datetime]');

    if (timeEl && timeEl.getAttribute('datetime')) {
      var parsed = Date.parse(timeEl.getAttribute('datetime'));
      if (!Number.isNaN(parsed)) return Math.floor(parsed / 1000);
    }

    return 0;
  }

  function getCurrentPage() {
    var page = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    return Number.isNaN(page) || page < 1 ? 1 : page;
  }

  function buildPageUrl(page, hash) {
    var url = new URL(window.location.href);

    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }

    url.hash = hash || '';
    return url.pathname + url.search + url.hash;
  }

  var PREV_ICON = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg>';
  var NEXT_ICON = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg>';

  function buildPaginationParts(currentPage, totalPages) {
    var pages = {};
    var parts = [];
    var page;
    var sortedPages;

    pages[1] = true;
    pages[totalPages] = true;

    for (page = currentPage - 2; page <= currentPage + 2; page += 1) {
      if (page >= 1 && page <= totalPages) {
        pages[page] = true;
      }
    }

    sortedPages = Object.keys(pages).map(Number).sort(function (a, b) {
      return a - b;
    });

    sortedPages.forEach(function (pageNumber, pageIndex) {
      if (pageIndex > 0 && pageNumber - sortedPages[pageIndex - 1] > 1) {
        parts.push({ type: 'ellipsis' });
      }

      parts.push({
        type: 'page',
        page: pageNumber,
        current: pageNumber === currentPage
      });
    });

    return parts;
  }

  function renderPagination(container, currentPage, totalPages, hash) {
    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    var parts = buildPaginationParts(currentPage, totalPages);
    var html = '<div class="pagination">';

    if (currentPage > 1) {
      html += '<span class="prev"><a href="' + buildPageUrl(currentPage - 1, hash) + '" title="Previous">' +
        PREV_ICON +
        '<span class="icon__fallback-text">Previous</span></a></span>';
    }

    parts.forEach(function (part) {
      if (part.type === 'ellipsis') {
        html += '<span class="page">&hellip;</span>';
        return;
      }

      if (part.current) {
        html += '<span class="page current">' + part.page + '</span>';
        return;
      }

      html += '<span class="page"><a href="' + buildPageUrl(part.page, hash) + '">' + part.page + '</a></span>';
    });

    if (currentPage < totalPages) {
      html += '<span class="next"><a href="' + buildPageUrl(currentPage + 1, hash) + '" title="Next">' +
        NEXT_ICON +
        '<span class="icon__fallback-text">Next</span></a></span>';
    }

    html += '</div>';
    container.innerHTML = html;
  }

  function getFetchPageSize(section) {
    var fetchPageSize = parseInt(section.dataset.fetchPageSize || String(DEFAULT_FETCH_PAGE_SIZE), 10);
    return Number.isNaN(fetchPageSize) ? DEFAULT_FETCH_PAGE_SIZE : fetchPageSize;
  }

  function getDisplayLimit(section) {
    if (section.dataset.limitPosts !== 'true') {
      return null;
    }

    var postLimit = parseInt(section.dataset.postLimit || '12', 10);
    return Number.isNaN(postLimit) ? 12 : postLimit;
  }

  function buildSectionUrl(blogUrl, sectionId, page) {
    var url = new URL(blogUrl, window.location.origin);
    url.searchParams.set('sections', sectionId);
    url.searchParams.delete('page');

    if (page > 1) {
      url.searchParams.set('page', String(page));
    }

    return url.pathname + url.search;
  }

  async function fetchSectionHtml(blogUrl, sectionId, page) {
    var response = await fetch(buildSectionUrl(blogUrl, sectionId, page), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch blog section page ' + page);
    }

    var data = await response.json();
    return data[sectionId] || '';
  }

  function readCache(cacheKey) {
    try {
      var raw = sessionStorage.getItem(cacheKey);
      if (!raw) return null;

      var cached = JSON.parse(raw);
      if (!cached || !cached.expiresAt || Date.now() > cached.expiresAt) {
        sessionStorage.removeItem(cacheKey);
        return null;
      }

      return cached.cards || null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(cacheKey, cards) {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({
        expiresAt: Date.now() + CACHE_TTL_MS,
        cards: cards
      }));
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function cardsFromDom(section) {
    var source = section.querySelector('[data-gk-blog-posts-source]');
    var cards = source
      ? Array.from(source.querySelectorAll('.gk-blog-post-card'))
      : Array.from(section.querySelectorAll('.gk-blog-posts-grid .gk-blog-post-card'));

    return cards.map(function (card) {
      var handle = card.getAttribute('data-article-handle');
      return {
        handle: handle,
        updatedAt: getCardTimestamp(card),
        html: card.outerHTML
      };
    }).filter(function (card) {
      return card.handle;
    });
  }

  function mergeCards(existingCards, html) {
    var cardsByHandle = new Map();

    existingCards.forEach(function (card) {
      cardsByHandle.set(card.handle, card);
    });

    parseCardsFromHtml(html).forEach(function (card) {
      var handle = card.getAttribute('data-article-handle');

      if (!handle) {
        var titleLink = card.querySelector('.gk-blog-post-card__title a');
        if (titleLink && titleLink.getAttribute('href')) {
          var parts = titleLink.getAttribute('href').split('/').filter(Boolean);
          handle = parts[parts.length - 1];
        }
      }

      if (!handle || cardsByHandle.has(handle)) return;

      cardsByHandle.set(handle, {
        handle: handle,
        updatedAt: getCardTimestamp(card),
        html: card.outerHTML
      });
    });

    return Array.from(cardsByHandle.values()).sort(function (a, b) {
      return b.updatedAt - a.updatedAt;
    });
  }

  async function fetchAllCards(section) {
    var sectionId = section.dataset.sectionId;
    var blogUrl = section.dataset.blogUrl || ('/blogs/' + section.dataset.blogHandle);
    var articlesCount = parseInt(section.dataset.articlesCount || '0', 10);
    var fetchPageSize = getFetchPageSize(section);
    var cacheKey = 'gk-blog-posts:' + section.dataset.blogHandle + ':' + sectionId;
    var cached = readCache(cacheKey);

    if (cached && cached.length) {
      return cached;
    }

    var cards = cardsFromDom(section);
    var totalFetchPages = articlesCount > 0
      ? Math.ceil(articlesCount / fetchPageSize)
      : 1;

    if (totalFetchPages <= 1) {
      cards = cards.sort(function (a, b) {
        return b.updatedAt - a.updatedAt;
      });

      if (cards.length) {
        writeCache(cacheKey, cards);
      }

      return cards;
    }

    var fetchPages = [];

    for (var page = cards.length ? 2 : 1; page <= totalFetchPages; page += 1) {
      fetchPages.push(page);
    }

    if (!fetchPages.length) {
      cards = cards.sort(function (a, b) {
        return b.updatedAt - a.updatedAt;
      });

      if (cards.length) {
        writeCache(cacheKey, cards);
      }

      return cards;
    }

    var responses = await Promise.all(fetchPages.map(function (page) {
      return fetchSectionHtml(blogUrl, sectionId, page);
    }));

    responses.forEach(function (html) {
      cards = mergeCards(cards, html);
    });

    if (cards.length) {
      writeCache(cacheKey, cards);
    }

    return cards;
  }

  function renderCards(section, grid, pagination, cards) {
    var displayLimit = getDisplayLimit(section);
    var limitPosts = section.dataset.limitPosts === 'true';
    var showPagination = section.dataset.showPagination === 'true';
    var hash = '#shopify-section-' + section.dataset.sectionId;
    var visibleCards = cards;
    var currentPage = 1;
    var totalPages = 1;

    if (displayLimit) {
      totalPages = Math.max(1, Math.ceil(cards.length / displayLimit));
      currentPage = Math.min(getCurrentPage(), totalPages);
      var start = (currentPage - 1) * displayLimit;
      visibleCards = cards.slice(start, start + displayLimit);
    }

    grid.innerHTML = visibleCards.map(function (card) {
      return card.html;
    }).join('');

    grid.classList.remove('is-updating');

    if (window.lazyload && typeof window.lazyload.update === 'function') {
      window.lazyload.update();
    }

    if (pagination && limitPosts && showPagination) {
      renderPagination(pagination, currentPage, totalPages, hash);
    } else if (pagination) {
      pagination.innerHTML = '';
    }
  }

  async function initSection(section) {
    var grid = section.querySelector('[data-gk-blog-posts-grid]');
    var pagination = section.querySelector('[data-gk-blog-posts-pagination]');

    if (!section.dataset.sectionId || !section.dataset.blogHandle || !grid) {
      return;
    }

    var cacheKey = 'gk-blog-posts:' + section.dataset.blogHandle + ':' + section.dataset.sectionId;
    var cached = readCache(cacheKey);

    if (cached && cached.length) {
      renderCards(section, grid, pagination, cached);
      return;
    }

    var initialCards = cardsFromDom(section);
    var sortedInitial = initialCards.slice().sort(function (a, b) {
      return b.updatedAt - a.updatedAt;
    });

    if (sortedInitial.length) {
      renderCards(section, grid, pagination, sortedInitial);
    }

    try {
      var articlesCount = parseInt(section.dataset.articlesCount || '0', 10);
      var fetchPageSize = getFetchPageSize(section);
      var needsMorePages = articlesCount > fetchPageSize;

      if (!needsMorePages) {
        if (sortedInitial.length) {
          writeCache(cacheKey, sortedInitial);
        }
        return;
      }

      grid.classList.add('is-updating');
      var cards = await fetchAllCards(section);
      renderCards(section, grid, pagination, cards);
    } catch (error) {
      grid.classList.remove('is-updating');
      console.error('GK blog posts sort failed:', error);
    }
  }

  function init() {
    document.querySelectorAll('[data-gk-blog-posts]').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
